import { FormControlLabel, Checkbox } from "@mui/material";
import styles from "./styles";
import useStyles from "@hooks/useStyle";
import { MvCheckboxPropsInterface } from "@mv-components/types";

const MvCheckbox = (props: MvCheckboxPropsInterface) => {
	const { itemKey, value, label, onChange, labelClassName, valid, touched } = props;
	const { classes, cx } = useStyles(styles) as any;
	let isError = false;
	if (typeof valid === "object" && !valid.isValid && touched) {
		isError = true;
	} else if (typeof valid === "boolean" && !value && touched) {
		isError = true;
	}
	return (
		<FormControlLabel
			control={
				<Checkbox
					checked={value ?? false}
					onChange={onChange(itemKey)}
					inputProps={{
						"aria-label": "primary checkbox",
					}}
				/>
			}
			classes={{
				label: cx(labelClassName, isError ? classes.error : ""),
			}}
			label={label}
		/>
	);
};

export default MvCheckbox;
